import React, { useEffect, useState } from "react";
import AudioPlayer from "../QuestionPage/AudioPlayer";
import ExamPanel from "./ExamPanel";

export default function HeadphoneCheckPage() {
  const [audioLink, setAudioLink] = useState("");

  useEffect(() => {
    const fetchSignedUrl = async () => {
      try {
        const res = await fetch("/ptedata/ptemedia/001_1585917752.mp3");
        const data = await res.json();
        setAudioLink(data.url);
      } catch (err) {
        console.error("Failed to fetch audio URL", err);
      }
    };

    fetchSignedUrl();
  }, []);

  return (
    <ExamPanel
      eyebrow="System check"
      title="Headset Check"
      instructions={[
        "This is an opportunity to check that your headset is working correctly.",
        "Put your headset on and adjust it so it sits comfortably over your ears.",
        "When you are ready, play the sample audio. If you cannot hear it clearly, raise your hand for assistance.",
      ]}
      media={
        <img
          className="h-28 w-36 object-contain sm:h-32 sm:w-44"
          src="/image/headphones.jpg"
          alt="Headphones"
        />
      }
      footer={
        <ul className="list-disc space-y-2 pl-5">
          <li>During the test, audio recordings will start automatically.</li>
          <li>Please keep your headset on throughout the test.</li>
        </ul>
      }
    >
      <div className="max-w-3xl rounded-md border border-slate-200 bg-slate-50 p-4">
        <AudioPlayer audioSrc={audioLink} />
      </div>
    </ExamPanel>
  );
}
